import { Preview } from "../../../../types/IAction";
import * as actions from "../../../actions/comisionAnualidad";
import {
  PostComisionAnualidadCargaMetas,
  GetComisionAnualidadMetas
} from "../../../reducers/comisionAnualidad";

export interface ConfiguracionMetasDispatcher {
  postCargaMetas: (
    formData: FormData,
    confirmar: boolean,
    periodo: string
  ) => Promise<Preview<PostComisionAnualidadCargaMetas>>;
  getMetas: () => Promise<Preview<GetComisionAnualidadMetas>>;
}

export const configuracionMetasDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ConfiguracionMetasDispatcher = dispatch => ({
  postCargaMetas: (formData: FormData, confirmar: boolean, periodo: string) => {
    return dispatch(actions.postCargaMetas(formData, confirmar, periodo));
  },
  getMetas: () => {
    return dispatch(actions.getMetas());
  }
});
